module.exports = "//static.hsappstatic.net/salesImages/static-1.403/integrations/hubspot-coffee.jpg"